// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1b0HU","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2f-8u"};